<form [formGroup]="fifthFormGroup">
  <div class="">
    <div class="grid-container grid-container-thirds mx-32 mt-32">
      <div class="grid-item">
        <h3 class="m-0 mb-16">Calibrated</h3>
        <div class="flex flex-row justify-between w-50">
          <p class="m-0">No</p>
          <mat-slide-toggle
            formControlName="calibrated"
            (change)="updateCalibrated()"
          ></mat-slide-toggle>
          <p class="m-0">Yes</p>
        </div>
      </div>

      <div class="grid-item">
        <h3 class="m-0 mb-16">Repairs Complete</h3>
        <div class="flex flex-row justify-between w-50">
          <p class="m-0">No</p>
          <mat-slide-toggle
            formControlName="repairsComplete"
            (change)="updateRepairsComplete()"
          ></mat-slide-toggle>
          <p class="m-0">Yes</p>
        </div>
      </div>

      <div class="grid-item">
        <h3 class="m-0 mb-16">Pressure Test Required</h3>
        <div class="flex flex-row justify-between w-50">
          <p class="m-0">No</p>
          <mat-slide-toggle
            formControlName="pressureTest"
            (change)="updatePressureTest()"
          ></mat-slide-toggle>
          <p class="m-0">Yes</p>
        </div>
      </div>
    </div>

    <div class="grid-container grid-container-1-2thirds mx-32 mt-32">
      <div class="grid-item">
        <mat-form-field class="w-full fuse-mat-dense" subscriptSizing="dynamic">
          <mat-label>Shipping Weight (kg)</mat-label>
          <input
            matInput
            placeholder="Shipping Weight (kg)"
            formControlName="weight"
            type="number"
            (change)="updateWeight()"
          />
        </mat-form-field>
      </div>

      <div class="grid-item">
        <mat-form-field class="w-full fuse-mat-dense" subscriptSizing="dynamic">
          <mat-label>Dimensions</mat-label>
          <input
            matInput
            placeholder="Dimensions"
            formControlName="dimensions"
            (change)="updateDimensions()"
          />
        </mat-form-field>
      </div>

      <div class="grid-item">
        <mat-form-field class="w-full fuse-mat-dense" subscriptSizing="dynamic">
          <mat-label>Packaging</mat-label>
          <mat-select
            [value]="model.packaging?.id"
            (selectionChange)="updatePackaging($event)"
          >
            <mat-option
              *ngFor="let packaging of packagingList"
              [value]="packaging?.id"
            >
              {{ packaging.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="grid-item">
        <mat-form-field class="w-full fuse-mat-dense" subscriptSizing="dynamic">
          <mat-label>Additional Packaging Info</mat-label>
          <input
            matInput
            placeholder="Additional Packaging Info"
            formControlName="additionalPackagingInfo"
            (change)="updateAdditionalPackagingInfo()"
          />
        </mat-form-field>
      </div>
    </div>

    <!-- Navigation -->
    <div
      class="flex justify-center items-end w-full mt-32 gap-4"
      fxLayout="row"
    >
      <button mat-stroked-button color="primary" class="border-primary text-xl px-32 min-w-[120px]" (click)="close()">
        Cancel
      </button>
      <!-- <button *ngIf="fifthFormGroup.controls['pressureTest'].value" mat-flat-button color="primary" class="text-xl px-32" (click)="save(true)">
        Proceed to Pressure Test
      </button> -->
      <button mat-flat-button color="primary" class="text-xl px-32 min-w-[120px]" (click)="save()">
        Save
      </button>
    </div>
  </div>
</form>
